import MainView from "./MainView";
import C_CockpitParts from "../const/C_CockpitParts";


class MainViewLandscape extends MainView
{
    constructor()
    {
        super();
    }


    addCockpit()
    {
        this.partsPerShip = C_CockpitParts.partsLandscape;
        super.addCockpit();
    }


    addButtons()
    {
        this.navButSize = 10;
        this.butHorizontalPadding = 3;
        this.backButBotPadding = 12;
        this.payButBotPadding = 23;
        this.soundButBotPadding = 12;

        super.addButtons();
    }
}

export default MainViewLandscape;